<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="text-h5 primary--text">Statistika registra radova</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="6">
        <StatisticCard :item="items[0]" :number="statistic.broj_radova"/>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <StatisticCard :item="items[1]" :number="statistic.broj_autora"/>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <StatisticCard :item="items[2]" :number="statistic.broj_studenata_autora"/>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <StatisticCard :item="items[3]" :number="statistic.broj_uposlenika_autora"/>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <StatisticCard :item="items[4]" :number="statistic.broj_stranih_autora"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import StatisticCard from "@/views/components/StatisticCard.vue";

export default {
  name: "Statistika",
  components: {StatisticCard},
  created() {
    this.getStatistic()
  },
  methods: {
    getStatistic() {
      axios.get(`/registar_v2/statistics`).then((response) => {
        console.log(response)
        this.statistic = response.data
      })
    }
  },
  data () {
    return {
      statistic: null,
      items: [
        {
          title: 'Ukupan Broj radova',
          icon: 'mdi-bookshelf'
        },
        {
          title: 'Ukupan broj autora',
          icon: 'mdi-account-group'
        },
        {
          title: 'Ukupan broj studenata autora',
          icon: 'mdi-account-multiple'
        },
        {
          title: 'Ukupan broj uposlenika autora',
          icon: 'mdi-account-multiple-outline'
        },
        {
          title: 'Ukupan broj stranih autora',
          icon: 'mdi-account-supervisor'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>